
//
// Nomes dos locais de estocagem.
//
export const ENTITY = 'entity'
export const SYSTEM = 'system'

//
// Estocagem de uma entidade do tipo {Keep.Paper.Design.IEntity}.
//
export const STORE = 'store'
export const STORE_ENTITY = `${ENTITY}/${STORE}`

//
// Lincagem entre duas entidades para autorefresh em cascata
//
export const BIND = 'bind'
export const BIND_ENTITY = `${ENTITY}/${BIND}`

//
// Descarta de uma entidade do tipo {Keep.Paper.Design.IEntity} estocada.
//
export const DISCARD = 'discard'
export const DISCARD_ENTITY = `${ENTITY}/${DISCARD}`

//
// Descarta todas as entidades.
//
export const DISCARD_ALL = 'discardAll'
export const DISCARD_ALL_ENTITIES = `${ENTITY}/${DISCARD_ALL}`

//
// Pacote de entidades classifacadas como Papers.
//
export const PAPERS = 'papers'
export const PAPERS_GETTER = `${ENTITY}/${PAPERS}`

//
// Operação de travamento.
//
export const LOCK = 'lock'
export const LOCK_REQUEST = `${SYSTEM}/${LOCK}`

//
// Operação de destravamento.
//
export const UNLOCK = 'unlock'
export const UNLOCK_REQUEST = `${SYSTEM}/${UNLOCK}`

//
// Estocagem de identidade de usuário.
//
export const IDENTITY = 'identity'
export const STORE_IDENTITY = `${SYSTEM}/storeIdentity`

//
// Tema claro/escuro.
//
export const DARK = 'dark'
export const SET_DARK = `${SYSTEM}/setDark`

//
// Estado do menu.
//
export const MENU = 'menu'
export const SET_MENU = `${SYSTEM}/setMenu`
